import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerTransactionActions } from "../../actions/consumer-log.actions";
import { AchBoStatusState } from "../../models/consumer-logs/ach-bo-status-state";

const initialState: AchBoStatusState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerTransactionActions.achBoStatus.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerTransactionActions.achBoStatus.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(ConsumerTransactionActions.achBoStatus.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function achBoStatusReducer(state: AchBoStatusState | undefined, action: Action) {
	return reducer(state, action);
}
